import { render, staticRenderFns } from "./BookingAdditionalChargeSummaryList.vue?vue&type=template&id=33a542c2&scoped=true&"
import script from "./BookingAdditionalChargeSummaryList.vue?vue&type=script&lang=js&"
export * from "./BookingAdditionalChargeSummaryList.vue?vue&type=script&lang=js&"
import style0 from "./BookingAdditionalChargeSummaryList.vue?vue&type=style&index=0&id=33a542c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a542c2",
  null
  
)

export default component.exports